import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionFacade } from '@app/store/session';
import { Permission } from '@app/store/session/models';

export const hasPermission = (permission: Permission): CanActivateFn => {
    return () => {
        const router = inject(Router);
        const sessionFacade = inject(SessionFacade);

        return sessionFacade.hasPermission(permission) || router.createUrlTree(['/dashboard']);
    };
};
